import { IconButton, Stack, Typography } from '@mui/material';
import { Box } from '@mui/system';
import styled from '@mui/system/styled';
import CustomButton from 'components/Button/CustomButton';

export const Container = styled('div')({
  padding: '24px 40px 16px 40px',
});

export const Header = styled('div')({
  paddingTop: '16px',
  paddingBottom: '16px',
  paddingRight: '16px',
  color: '#000000',
  fontWeight: 700,
  fontSize: 22,
  lineHeight: '30.05px',
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: 'space-between',
});

export const CardsContainer = styled(Box)({
  display: 'flex',
  flexWrap: 'wrap',
  gap: '16px',
  marginTop: '16px',
  padding: '16px',
  borderRadius: '16px',
  background:
    'linear-gradient(90deg, rgba(80, 127, 239, 0.18) 0%, rgba(138, 74, 236, 0.18) 100%)',
});
export const Card = styled(Box)({
  padding: '16px',
  flex: 1,
  borderRadius: '12px',
  background: '#fff',
  boxShadow: '0px 2px 1px 0px #00000014',
  border: '1px solid #fff',
  cursor: 'pointer',
  transition: '0.4s ease all',
  '&:hover': {
    boxShadow: '0px 4px 10px 0px #00000017',
    border: '1px solid #6868FE',
  },
  '& .icon': {
    background: '#6868FE',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: 42,
    height: 42,
    marginBottom: '10px',
    borderRadius: 11,
    '& svg path': {
      stroke: '#fff',
    },
  },
  '& .title': {
    fontWeight: 800,
    fontSize: 15,
    color: '#000000',
  },
  '& .content': {
    fontWeight: 500,
    fontSize: 13,
    color: '#424242',
  },
});

export const PreBuildReportsCnt = styled(Box)({
  background: '#fff',
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'flex-start',
  gap: '16px',
});

export const ReportColumn = styled(Box)({
  background: '#F1F3F4',
  borderRadius: '16px',
  padding: '16px',
  display: 'flex',
  flex: 1,
  flexDirection: 'column',
  gap: '12px',
  '& .title': {
    fontWeight: 800,
    fontSize: 15,
    color: '#000000',
    marginBottom: '8px',
  },
});

export const ReportCard = styled(Box)({
  borderRadius: '12px',
  padding: '10px',
  display: 'flex',
  alignItems: 'center',
  gap: '12px',
  background: '#fff',
  border: '1px solid #E0E0E0',
  cursor: 'pointer',
  transition: 'all 0.2s ease-in-out',
  '&:hover': {
    background: '#f8f9fa',
    border: '1px solid #6868FE',
    boxShadow: '0px 2px 8px rgba(104, 104, 254, 0.15)',
  },
  '& .reportTitle': {
    fontWeight: 700,
    fontSize: 14,
    color: '#000',
  },
});

export const ImgBox = styled(Stack)({
  height: 42,
  width: 42,
  borderRadius: '11px',
  alignItems: 'center',
  justifyContent: 'center',
});

export const TabsList = styled('div')({
  display: 'flex',
  alignItems: 'center',
  padding: '16px 0',
  overflowX: 'auto',
  '& .tab': {
    fontSize: 14,
    fontWeight: 600,
    textTransform: 'capitalize',
    marginRight: 8,
    borderRadius: 100,
    cursor: 'pointer',
    color: '#000000',
    padding: '12px 16px',
    backgroundColor: '#FFFFFF',
    border: '1px solid #E0E0E0',
    lineHeight: '16.39px',
    '&:hover': {
      background: 'rgba(0, 0, 0, 0.15)',
    },
  },
  '& .tab.selectedTab': {
    background: '#6868FE',
    color: '#fff',
  },
});
